function getLocation(job) {

  if (job.location) {
    return job.location;
  }

  return [
    job.city,
    job.province
  ]
    .filter(Boolean)
    .join(', ');
}

export default function JobCard({
  job,
  selected,
  onClick
}) {

  return (
    <button
      className={`job-card ${selected ? 'selected' : ''}`}
      onClick={() => onClick(job)}
    >

      <div className="job-card-tags">

        {
          job.source === 'jobbank'
            ? (
              <span className="jobbank-tag">
                🍁 Canada Job Bank
              </span>
            )
            : (
              <span className="local-tag">
                🏢 Local Employer
              </span>
            )
        }

      </div>

      <h3>
        {job.title}
      </h3>

      <p className="company-name">
        {job.company}
      </p>

      <p className="job-location">
        {getLocation(job)}
      </p>

      {
        !job.salary && (job.type || job.workplaceType) && (
          <p>
            {job.type || job.workplaceType}
          </p>
        )
      }

    </button>
  );
}
